import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { ACTIVITIES } from '../../data/staticContent';

const HomeActivities = () => {
  const { t } = useLanguage();

  return (
    <section className="section-pad-alt">
      <div className="container">

        {/* Header */}
        <div className="text-center mb-5">
          <span className="eyebrow">
            <i className="bi bi-heart me-2"></i>Our Work
          </span>
          <h2 className="section-title">{t('home.activitiesTitle')}</h2>
          <div className="divider-brand-center"></div>
          <p className="section-subtitle" style={{maxWidth:'520px',margin:'0 auto'}}>
            {t('home.activitiesSubtitle')}
          </p>
        </div>

        {/* Activity cards */}
        <div className="row g-4">
          {ACTIVITIES.map(({ key, icon, iconClass }, idx) => (
            <div className="col-lg-4 col-md-6" key={key}>
              <div className={`cf-card anim-fade-up anim-delay-${idx + 1}`}>
                <div className={`card-icon-wrap ${iconClass}`}>
                  <i className={`bi ${icon}`}></i>
                </div>
                <div className="cf-card-title">{t(`activities.${key}Title`)}</div>
                <p className="cf-card-text mb-3">{t(`activities.${key}Desc`)}</p>
                <Link
                  to="/our-activities"
                  className="font-sans text-brand text-decoration-none d-inline-flex align-items-center gap-1"
                  style={{fontSize:'0.8rem',fontWeight:600}}
                >
                  {t('common.learnMore')} <i className="bi bi-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-5">
          <Link to="/our-activities" className="btn-accent">
            {t('common.viewAll')} <i className="bi bi-arrow-right"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeActivities;
